import {datadogRum} from '@datadog/browser-rum';
import {isUndefined} from 'lodash';

import {FrontConfig} from '../../../srcCommon/bundler/bundlerDefineConfig';
import {AppState} from '../../store/appState';
import {AppStore} from '../../store/appStore';
import {getCompany} from '../../store/data/company/companySelectors';
import {getUserId} from '../../store/data/teammates/teammatesSelectors';
import {getHasDatadogRum} from '../../store/featureFlags/featureFlagsSelectors';

/*
 * Constants.
 */

const applicationId = '1e982d06-3dcd-4eb3-9784-f419170f8311';
const clientToken = 'pub5ec89c63f9333934dd07b6ea8c3c510e';
const service = 'front-client';

/*
 * API.
 */

export function setupDatadogRealUserMonitoring(store: AppStore) {
  store.subscribe(() => initializeIfNecessary(store.getState()));
  initializeIfNecessary(store.getState());
}

/*
 * Helpers.
 */

let isInitialized = false;

function initializeIfNecessary(state: AppState) {
  if (isInitialized) {
    return;
  }

  const hasDatadogRum = getHasDatadogRum(state);
  if (!hasDatadogRum) {
    return;
  }

  datadogRum.init({
    applicationId,
    clientToken,
    service,
    env: FrontConfig.FRONT_ENV,
    version: FrontConfig.GIT_COMMIT,
    // For now, prevent automatic collection of user clicks, which may include sensitive and private data.
    trackInteractions: false,
  });
  isInitialized = true;

  const {region, cell, id: companyId} = getCompany(state);

  if (!isUndefined(region)) {
    datadogRum.addRumGlobalContext('region', region);
  }

  if (!isUndefined(cell)) {
    datadogRum.addRumGlobalContext('cell', cell);
  }

  const userId = getUserId(state);

  datadogRum.setUser({
    id: String(userId),
    company_id: companyId,
  });
}
